import Page from 'src/components/page/page';
import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import BannerForm from './components/banner-form';
import useHomeBannersDetails from './home-banners.hook';

export default function HomeBannersDetails() {
  const hook = useHomeBannersDetails();
  return (
    <Page title={hook.isEdit ? 'Editar Banner' : 'Cadastrar Banner'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={hook.isEdit ? 'Editar Banner' : 'Cadastrar Banner'}
          links={[]}
        />
        {hook.isLoadingDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <BannerForm hook={hook} />
        )}
      </Container>
    </Page>
  );
}
